import { createActionGroup, props } from '@ngrx/store';

import { ActivityNotification } from '@ninety/platform/models/user/user-activity.model';

export const UserActivityActions = createActionGroup({
  source: 'User Activity',
  events: {
    'Activity Restored': props<{ notification: ActivityNotification }>(),
    /** Inactivity reload prompt was shown. hoursInactive = total inactivity (1-decimal) when it opened. */
    'Inactivity Reload Prompt Opened': props<{ hoursInactive: number }>(),
    /** Inactivity reload prompt was closed. shouldReload = true when the user chose Reload. */
    'Inactivity Reload Prompt Closed': props<{ hoursInactive: number; shouldReload: boolean }>(),
  },
});
